import { callWidget, visibilityCommand } from './chat-commands';

const HiddenBodyClass = 'chat-hidden';
const VendorLauncherId = 'chat-overlay-container';
const LauncherVisibleClass = 'visible';

const vendorLauncher = () => document.getElementById(VendorLauncherId);

const launcherRevealed = () =>
  Boolean(vendorLauncher()?.classList.contains(LauncherVisibleClass));

const widgetShownInDom = () =>
  !document.body.classList.contains(HiddenBodyClass) || launcherRevealed();

const applyHiddenDom = () => {
  document.body.classList.add(HiddenBodyClass);
  vendorLauncher()?.classList.remove(LauncherVisibleClass);
};

const hideWidget = () => callWidget(visibilityCommand(true));

const reassertHidden = () => {
  if (!widgetShownInDom()) return;

  hideWidget();
  applyHiddenDom();
};

const watchLauncher = (observer) => {
  const launcher = vendorLauncher();

  if (launcher) observer.observe(launcher, { attributes: true, attributeFilter: ['class'] });
};

const watchVendorDom = (observer) => {
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true
  });
  watchLauncher(observer);
};

export const enforceChatHidden = () => {
  applyHiddenDom();

  const observer = new MutationObserver(() => {
    reassertHidden();
    watchLauncher(observer);
  });

  watchVendorDom(observer);

  return () => {
    observer.disconnect();
    hideWidget();
  };
};
